import {SERVICE_LOADING, SERVICE_SUCCESS, SERVICE_DELETE, SERVICE_ERROR} from "./type";

export const servicesReducer = (state: any, action: any) => {
  switch (action.type) {
    case SERVICE_LOADING:
      return {...state, loading: true, error: null}
    
    case SERVICE_SUCCESS:
      if(Array.isArray(action.payload)){
        return {...state, loading: false, services: action.payload}
      }
      
      if(typeof action.payload === "object"){
        const updated = action.payload;

        const exists = state.services.some((service: any) => service.id === updated.id);

        if(exists){
          return {
            ...state,
            loading: false,
            services: state.services.map((service: any) => 
              service.id === updated.id ? updated : service
            )
          }
        }
      }

      return state;

    case SERVICE_DELETE: 
      return {
        ...state,
        services: state.services.filter((service: any) => service.id !== action.payload)
      }

    case SERVICE_ERROR:
      return {...state, loading: false, error: action.payload}
      
    default:
      return state;
  }
}